import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_branch_settlement_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid:  fromDatatype.GuidDataFieldInterface;
  applet_guid:  fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  used_for_purchases: boolean;
  used_for_sales: boolean;
}

export class bl_fi_mst_branch_settlement_method_RowClass implements bl_fi_mst_branch_settlement_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid:  fromDatatype.GuidDataFieldInterface;
  applet_guid:  fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  used_for_purchases: boolean;
  used_for_sales: boolean;
}
